import Viewer from "@phuocng/react-pdf-viewer";
import React, {FC} from "react";
import './pdfViewer.scss';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import { pdfjs } from "react-pdf";
const pdfjsWorker = require('pdfjs-dist/build/pdf.worker.entry').default;
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

interface PdfViewerProps{
    fileUrl: string;
}

const PdfViewer:FC<PdfViewerProps> = ({fileUrl}) => {
    return(
        <div className='pdf-content'>
            <div style={{ height: '750px' }}>
                {fileUrl &&<Viewer fileUrl={fileUrl} />}
            </div>
        </div>
    )
}

export default PdfViewer;
